export default __webpack_public_path__ + "static/media/logoLecca.403f41b5.png";